import './index.css';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import GridComponent from './grid.jsx';
import {compose} from 'redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { setMataProjectId, setProjectTitle, setProjectTitleold } from '../store/project-state';
// import {setUserLoggedOut} from '../../reducers/user-state.js';
// import myWorkImg from './mywork.png';
// import sharedMessages from '../../lib/shared-messages';
// import { Box } from "@chakra-ui/layout";
import {message, Modal} from 'antd';
import CustomModal from '../containers/custom-modal';
import modalHeadBack from '../lib/assets/modalWifi.png'
import { setLoadingModal } from '../store/modals'
import {connect} from 'react-redux';
import { FileSystem, diff, VersionAction } from "../fs/fs";
import { createHost } from "../fs/host";
import { deployment } from "../deployment";
import { fetchMicroPython } from "../micropython/micropython";
import { useProject } from "../project/project-hooks";
// import {
//     InMemoryFSStorage
//   } from "../fs/storage";

const messages = defineMessages({
    myWorkTitle: {
        defaultMessage: 'My Projects',
        description: 'My Projects',
        id: "meun-item-account-mywork"
    }
})
class MyProjectModal extends React.Component {
    constructor (props){
        super(props);
        this.state = {
            isAgree: false,
            isClosed: false
        };
        bindAll(this, [
            'handleSubmit',
            'handleItemSelect'
        ]);

        this.handleRegister = () => {
            this.setState({
                isRegister: !this.state.isRegister
            });
        };
        this.project = null
        
    }

    componentDidMount () {
    }

    handleItemSelect (item) {
        // 解释：这里是点击项目后的处理，主要是判断是否需要替换当前项目，如果需要则弹出提示框，如果不需要则直接加载项目
        // const message = this.props.intl.formatMessage(sharedMessages.replaceProjectWarning);
        const openWork = () => {
            this.props.onCancel();
            this.props.onLoadingStarted(true);
            if (
                item.requiredProjectId &&
                item.requiredProjectId !== this.props.projectId
            ) {
                const urlParams = `/projects/${item.requiredProjectId}/editor?tutorial=${item.urlId}`;
                return window.open(window.location.origin + urlParams, '_blank');
            }
            // this.props.onActivateDeck(item.id);
            // activateDeck(item.id);
            this.loadProjectByURL(item);
        };
        if (this.props.projectChanged){
            // eslint-disable-next-line no-alert
            Modal.confirm({
                title: message,
                onOk: () => {
                    openWork();
                },
                onCancel () {}
            });
        } else {
            openWork();
        }


    }

    async loadProjectByURL (item) {
        // 请求原生fs等方法接口
        const logging = deployment.logging;
        const host = createHost(logging);
        const fs = new FileSystem(logging, host, fetchMicroPython);
        // 保存name和id到store
        this.props.setProjectTitle(item.name)
        this.props.setMataProjectId(item.id);
        this.props.setProjectTitleold(item.name)

        // 请求内容并且将文件内容转换为Uint8Array
        if (item.projectUrl) {
            fetch(item.projectUrl)
            .then(response => response.arrayBuffer())
            .then(buffer => {
                this.props.onLoadingStarted(false);
                    let name = `${item.name}.py`
                    fs.write(
                        name,
                        new Uint8Array(buffer),
                        VersionAction.INCREMENT
                    );

                    localStorage.setItem('pyName', item.name)

                    // 保存id和name到local
                    localStorage.setItem('projectTitle', name)
                    localStorage.setItem('projectId', item.id)

                    // 加载整个project无效，
                    // 整个页面刷新，临时方案
                    // console.log(
                    //     this.props.fs['fs']['fs']['project']['files'],
                    //     sessionStorage.length - 1,
                    //     this.props.projectNamesList.length,
                    //     name,
                    //     123
                    // )
                    if (this.props.projectNamesList.some(i => i === 'main')) {
                        if (this.props.fs['fs']['fs']['project']['files'].length === this.props.projectNamesList.length) {
                            this.props.onSetSelection(name, fs)
                        } else if (this.props.fs['fs']['fs']['project']['files'].length !== sessionStorage.length - 1 || this.props.fs['fs']['fs']['project']['files'].length !== sessionStorage.length - 2) {
                            location.reload()
                        }
                    } else {
                        if (this.props.fs['fs']['fs']['project']['files'].length === this.props.projectNamesList.length + 1) {
                            this.props.onSetSelection(name, fs)
                        } else if (this.props.fs['fs']['fs']['project']['files'].length !== sessionStorage.length - 1 || this.props.fs['fs']['fs']['project']['files'].length !== sessionStorage.length - 2) {
                            location.reload()
                        }
                    }
                    if (this.props.fs['fs']['fs']['project']['files'].some(i => i.name === name)) {
                        this.props.onSetSelection(name, fs)
                    } else {
                        location.reload()
                    }
            })
            .catch(e => {
                this.props.onLoadingStarted(false);
                // this.props.callBack(e);
            });
        }
    }

    handleSubmit (event) {
        event.preventDefault();
    }

    render () {
        const { intl } = this.props;
        return (
            <CustomModal
                id="MyProjectModal"
                className="main"
                fullScreen
                onRequestClose={this.props.onCancel}
                headerImageTop={modalHeadBack}
                contentLabel={intl.formatMessage(messages.myWorkTitle)}
            >
                <div className="content">
                    <GridComponent
                        filterable
                        id="myProjects"
                        // mataProjectId={this.props.mataProjectId}
                        // eslint-disable-next-line react/jsx-handler-names
                        onSetMataProjectId={this.props.setMataProjectId}
                        visible
                        onItemSelected={this.handleItemSelect}
                        // onItemSelected={actions.load}
                        // onRequestClose={this.props.onCancel}
                        // onUserLoggedOut={this.props.onUserLoggedOut}
                        // onLoadingStarted={this.props.onLoadingStarted}
                    />
                </div>
            </CustomModal>
        );
    }
}

MyProjectModal.propTypes = {
    onCancel: PropTypes.func,
    // intl: intlShape.isRequired,
    // onActivateDeck: PropTypes.func.isRequired,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onLoadingStarted: PropTypes.func,
    onSetProjectUnchanged: PropTypes.func,
    onUserLoggedOut: PropTypes.func,
    isStarted: PropTypes.bool,
    setMataProjectId: PropTypes.func,
    setProjectTitle: PropTypes.func,
    setProjectTitleold: PropTypes.func,
    mataProjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    projectChanged: PropTypes.bool,
    onSetSelection: PropTypes.func,
    fs: PropTypes.object
};
const mapStateToProps = state => {
    return {
        projectNamesList: state.projectStore.projectNamesList
    };
};
const mapDispatchToProps = dispatch => ({
    onLoadingStarted: (type) => dispatch(setLoadingModal(type)),
    setMataProjectId: projectId => dispatch(setMataProjectId(projectId)),
    setProjectTitle: title => dispatch(setProjectTitle(title)),
    setProjectTitleold: title => dispatch(setProjectTitleold(title))
});


export default compose(
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(MyProjectModal);
